<div class="info-page">
  <h3>{{ actionLabel }}</h3>
</div>

<form [formGroup]="form" (ngSubmit)="salvar()">
  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Título <sup class="text-danger">*</sup></label>
      <textarea id="title" class="form-control" rows="1" formControlName="description" placeholder="Título do Item" maxlength="180"></textarea>
      <app-field-message [field]="fieldMessageRequired('description')" [erros]="fieldErros('description')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Descrição</label>
      <textarea id="description_goal" class="form-control" rows="3" formControlName="description_goal" placeholder="Descrição do Item" maxlength="500"></textarea>
      <app-field-message [field]="fieldMessageRequired('description_goal')" [erros]="fieldErros('description_goal')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Responsável <sup class="text-danger" *ngIf="form?.get('agency_id')?.required">*</sup></label>
      <ng-select id="agency_id" class="ng-select-alternative" [items]="listOrgaos" bindLabel="str_nome" bindValue="num_codigo_pk" placeholder="Selecione" formControlName="agency_id">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('agency_id')" [erros]="fieldErros('agency_id')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b" *ngIf="list?.level_mon">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Nível de Acompanhamento</label>
      <ng-select id="level_mon_id" class="ng-select-alternative" [items]="list?.level_mon_list" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="level_mon_id">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('level_mon_id')" [erros]="fieldErros('level_mon_id')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1" *ngIf="entity?.progress && entity?.progress > 0; else previsto">Data de início</label>
      <ng-template #previsto>
        <label class="col-sm-12 pb-1">Data prevista para início <sup class="text-danger">*</sup></label>
      </ng-template>
      <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker [formControlName]="entity?.dt_foreseen_start ? 'dt_foreseen_start' : 'dt_start'" [readOnly]="entity?.dt_foreseen_start || entity?.dt_start" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', locale: 'pt-br' }" placeholder="dd/mm/aaaa" (change)="dataMask($event, 'dt_start')">
      <app-field-message [field]="fieldMessageRequired('dt_start')" [erros]="fieldErros('dt_start')"></app-field-message>
    </div>
  </div>

  <!-- se for clone desabilita -->
  <div class="form-group row m-b" *ngIf="true">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Data de conclusão cronograma <sup class="text-danger">*</sup></label>
      <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker [formControlName]="entity?.dt_foreseen_conclusion ? 'dt_foreseen_conclusion' : 'dt_conclusion'" [readOnly]="entity?.dt_foreseen_conclusion || entity?.dt_conclusion" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', locale: 'pt-br' }" placeholder="dd/mm/aaaa" (change)="dataMask($event, 'dt_conclusion')" [ngClass]="{'ng-invalid': dataFinal}">
      <app-field-message [field]="fieldMessageRequired('dt_conclusion') || dataFinal" [erros]="fieldErros('dt_conclusion')" [textErroServer]="dataFinal"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Data de conclusão Linha Base</label>
      <input id="bl_dt_foreseen_conclusion" class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="bl_dt_foreseen_conclusion" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', locale: 'pt-br' }" placeholder="dd/mm/aaaa">
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Responsável titular</label>
      <ng-select id="manager" class="ng-select-alternative" [items]="listUsuario" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="manager">
      </ng-select>
    </div>
  </div>


  <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Responsável adjunto</label>
      <ng-select id="adjunct" class="ng-select-alternative" [multiple]="true" [items]="listUsuario" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="adjunct">
      </ng-select>
    </div>
  </div>

  <!-- Table -->
  <div class="form-group row m-b">
    <div class="col-12 col-sm-10">
      <label class="col-sm-12 pb-1">Medida Física</label>
      <div class="system-table table-container system-table-m-b table-form">
        <div class="system-table-conteiner system-table-form-conteiner system-table-select">
          <table>
            <thead>
              <tr>
                <th>Título</th>
                <th>Unid. med.</th>
                <th>Casas decimais</th>
                <th>Meta</th>
                <th class="text-center btn-icon-td">Ações</th>
              </tr>
            </thead>
            <tbody formArrayName="extras">
              <tr *ngFor="let item of getFormArray().controls; let i = index" [formGroupName]="i">
                <td class="title">
                  <input type="text" class="form-control" formControlName="title">
                  <app-field-message [field]="fieldMessageRequireds('title', i)" [erros]="fieldErrosFormArray('title', i)"></app-field-message>
                </td>
                <td>
                  <ng-select class="ng-select-alternative" [items]="list?.units" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="unit_id">
                  </ng-select>
                  <app-field-message [field]="fieldMessageRequireds('unit_id', i)" [erros]="fieldErrosFormArray('unit_id', i)"></app-field-message>
                </td>
                <td>
                  <ng-select class="ng-select-alternative" [items]="list?.decimal_places" (change)="formatarMedidaFisica(i)" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="decimal_places">
                  </ng-select>
                  <app-field-message [field]="fieldMessageRequireds('decimal_places', i)" [erros]="fieldErrosFormArray('decimal_places', i)"></app-field-message>
                </td>
                <td>
                  <input type="text" class="form-control text-right" formControlName="goal" (keyup)="formatarMedidaFisica(i)">
                </td>
                <td>
                  <div class="btn-icon">
                    <span class="icon-table icon-red" (click)="removeMedida(i)">
                      <img src="assets/images/svgs/trash.svg" alt="Remover item" tooltip="Remover item" placement="bottom">
                    </span>
                  </div>
                </td>
              </tr>
              <tr *ngIf="!getFormArray().controls.length" class="border-b-radius">
                <td colspan="5" class="text-center">Nenhuma Medida Física Cadastrada</td>
              </tr>
            </tbody>
          </table>
        </div>
        <button class="btn btn-success btn-add-question mb-0" type="button" (click)="addMedida()">Nova Medida Física</button>
      </div>
    </div>
  </div>

  <!-- <div class="form-group row m-b">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">Dados adicionais</label>
      <ng-select id="pf_process_id" class="ng-select-alternative" [items]="list?.process_list" bindLabel="title" bindValue="id" placeholder="Selecione" formControlName="pf_process_id">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('pf_process_id')" [erros]="fieldErros('pf_process_id')"></app-field-message>
    </div>
  </div> -->

  <div class="form-group row">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Indicador Relacionado</label>
      <div class="row">
        <div class="col-sm-6 m-b">
          <ng-select id="related_ind_id" class="ng-select-alternative" [items]="list?.indicator" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="related_ind_id">
          </ng-select>
        </div>
        <div class="col-sm-6 m-b">
          <ng-select id="related_ind_pf_id" class="ng-select-alternative" (change)="changeProjetoIndicador()" [items]="list?.project" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="related_ind_pf_id">
          </ng-select>
          <app-field-message [field]="fieldMessageRequired('related_ind_pf_id')" [erros]="fieldErros('related_ind_pf_id')"></app-field-message>
        </div>
      </div>
    </div>
  </div>

  <div class="form-group row m-b" *ngIf="entity?.id">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">IRFE Relacionado</label>
      <ng-select id="irfe_id" class="ng-select-alternative" [items]="list?.irfe" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="irfe_id">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('irfe_id')" [erros]="fieldErros('irfe_id')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b" *ngIf="entity?.id">
    <div class="col-sm-4">
      <label class="col-sm-12 pb-1">IRCP Relacionado</label>
      <ng-select id="ircp_id" class="ng-select-alternative" [items]="list?.ircp" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="ircp_id">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('ircp_id')" [erros]="fieldErros('pf_proceircp_idss_id')"></app-field-message>
    </div>
  </div>

  <div class="hr-line-dashed"></div>
  <div class="form-group row d-flex justify-content-end">
    <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
      <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
      <button class="btn btn-primary" type="submit">Salvar</button>
    </div>
  </div>
</form>
<br>
<app-historico-atualizacoes-list [audit]="audit"></app-historico-atualizacoes-list>
<app-loading [loader]="isLoading"></app-loading>